/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Offline_UnavailableInputs */

const en_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic backup is not available in offline mode. Please configure Automatic Backup for local by going to Edit -> Options -> Automatic Backup`)
};

const fr_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sauvegarde automatique n’est pas disponible en mode hors ligne. Veuillez configurer la sauvegarde automatique locale via Édition -> Options -> Sauvegarde automatique`)
};

const de_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Datensicherung ist im Offline-Modus nicht verfügbar. Bitte konfigurieren Sie die automatische Datensicherung für lokale Anwendungen unter Bearbeiten → Optionen → Automatische Datensicherung.`)
};

const it_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il backup automatico non è disponibile in modalità offline. Configurare il backup automatico per la modalità locale andando su Modifica -> Opzioni -> Backup automatico`)
};

const ru_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое резервное копирование недоступно в автономном режиме. Для настройки автоматического резервного копирования локально перейдите в меню «Редактировать» -> «Параметры» -> «Автоматическое резервное копирование».`)
};

const es_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La copia de seguridad automática no está disponible en modo sin conexión. Configure la copia de seguridad automática localmente en Editar -> Opciones -> Copia de seguridad automática.`)
};

const zh_cn2_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线模式下无法使用自动备份。请通过“编辑”->“选项”->“自动备份”配置本地自动备份。`)
};

const ja_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインモードでは自動バックアップは利用できません。編集 -> オプション -> 自動バックアップでローカルの自動バックアップを設定してください。`)
};

const hi_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन मोड में स्वचालित बैकअप उपलब्ध नहीं है। कृपया एडिट -> ऑप्शंस -> ऑटोमैटिक बैकअप पर जाकर स्थानीय बैकअप के लिए स्वचालित बैकअप कॉन्फ़िगर करें।`)
};

const pt_pt2_automatic_save_offline_unavailable = /** @type {(inputs: Automatic_Save_Offline_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O backup automático não está disponível no modo offline. Configure o backup automático local acessando Editar -> Opções -> Backup Automático.`)
};

/**
* | output |
* | --- |
* | "Automatic backup is not available in offline mode. Please configure Automatic Backup for local by going to Edit -> Options -> Automatic Backup" |
*
* @param {Automatic_Save_Offline_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_offline_unavailable = /** @type {((inputs?: Automatic_Save_Offline_UnavailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Offline_UnavailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_offline_unavailable(inputs)
	if (locale === "de") return de_automatic_save_offline_unavailable(inputs)
	if (locale === "it") return it_automatic_save_offline_unavailable(inputs)
	if (locale === "ru") return ru_automatic_save_offline_unavailable(inputs)
	if (locale === "es") return es_automatic_save_offline_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_offline_unavailable(inputs)
	if (locale === "ja") return ja_automatic_save_offline_unavailable(inputs)
	if (locale === "hi") return hi_automatic_save_offline_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_offline_unavailable(inputs)
	return en_automatic_save_offline_unavailable(inputs)
});